import OthersChat from "./OthersChat";

export default OthersChat;
